// extracted by mini-css-extract-plugin
module.exports = {"hiddenNav":"seo-navigation_hiddenNav__DSVpq"};